export const DEFAULT_SHAREIMG =
  'https://media.winbaoxian.com/autoUpload/planbook/1561594277637_.pic_hd_7feb9fe70ec74de.jpg'
export const DEFAULT_AVATAR =
  '//media.winbaoxian.com/static/images/exam/bxs_default_logoImg.png'
export const LEFT_BG = '//media.winbaoxian.com/static/images/n3/pbf/family/bg3-l.png'
export const RIGHT_BG = '//media.winbaoxian.com/static/images/n3/pbf/family/bg3-r.png'
export const groupColor = [
  '#FFB73E',
  '#8DF5FA',
  '#84ADFF',
  '#7AD586',
  '#FFBD80',
  '#D3E57F',
  '#95D3FF',
  '#E2A1FF',
  '#FFF590',
  '#91DCB9',
  '#FF9E9E'
]